import StatusTag from './StatusTag'

export { StatusTag }
